import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CLINIC } from "../lib/api";
import { MapEmbed } from "../components/MapEmbed";

export default function Contact() {
  return (
    <div>
      <section className="bg-soft-cream">
        <div className="max-w-7xl mx-auto container-x py-16">
          <p className="text-brand-red font-semibold text-xs uppercase tracking-[0.2em] mb-3">Contact</p>
          <h1 className="font-display font-extrabold text-brand-navy text-4xl sm:text-5xl lg:text-6xl tracking-tight">Contactați-ne</h1>
          <p className="mt-5 text-brand-navy/75 text-lg max-w-2xl font-light">Pentru programări, întrebări sau informații suplimentare, vă stăm la dispoziție.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto container-x py-16 grid lg:grid-cols-2 gap-10">
        <div className="space-y-5">
          <ContactRow icon={Phone} title="Telefon" value={CLINIC.phonePretty} href={CLINIC.phoneTel} testId="contact-phone" />
          <ContactRow icon={Mail} title="Email programări" value={CLINIC.emailBookings} href={`mailto:${CLINIC.emailBookings}`} testId="contact-email-bookings" />
          <ContactRow icon={MapPin} title="Adresă" value={CLINIC.address} href="https://maps.google.com/?q=Str.+General+Eremia+Grigorescu+81,+Cluj-Napoca" testId="contact-address" />

          <div className="bg-white rounded-3xl p-6 border border-brand-yellow/40 shadow-sm">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-2xl bg-brand-green/15 flex items-center justify-center text-brand-green">
                <Clock className="w-6 h-6" />
              </div>
              <h3 className="font-display font-bold text-brand-navy text-lg">Program</h3>
            </div>
            <ul className="space-y-2 text-sm text-brand-navy/85">
              <li className="flex justify-between"><span className="font-semibold">CAS — Luni</span><span>10:00 – 13:00</span></li>
              <li className="flex justify-between"><span className="font-semibold">CAS — Marți</span><span>09:00 – 12:00</span></li>
              <li className="flex justify-between"><span className="font-semibold">CAS — Miercuri</span><span>14:00 – 17:00</span></li>
              <li className="flex justify-between"><span className="font-semibold">CAS — Joi</span><span>10:00 – 13:00</span></li>
              <li className="flex justify-between"><span className="font-semibold">CAS — Vineri</span><span>10:00 – 13:00</span></li>
              <li className="flex justify-between text-brand-navy/70 pt-2 border-t border-brand-beige"><span>Programări individuale</span><span>telefonic</span></li>
            </ul>
          </div>
        </div>

        <div className="rounded-3xl overflow-hidden shadow-soft border border-brand-yellow/40 min-h-[400px]">
          <MapEmbed
            title="Hartă Ro-Dental Cluj-Napoca"
            src={CLINIC.mapsEmbed}
            mapsUrl={CLINIC.googleMapsUrl}
            className="w-full h-full min-h-[400px]"
          />
        </div>
      </section>
    </div>
  );
}

function ContactRow({ icon: Icon, title, value, href, testId }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" className="block bg-white rounded-3xl p-6 border border-brand-yellow/40 shadow-sm hover:shadow-soft transition-shadow" data-testid={testId}>
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-2xl bg-brand-yellow flex items-center justify-center text-brand-navy">
          <Icon className="w-6 h-6" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-brand-navy/60 font-bold">{title}</div>
          <div className="font-display font-bold text-brand-navy text-lg">{value}</div>
        </div>
      </div>
    </a>
  );
}
